export default __webpack_public_path__ + "static/media/787.85d69446.jpg";